<template lang="html">
    <div class="meeting-room">
        <UiNotification/>
        <div class="video-call">
            <div class="remote-user-video">
                <span class="camera-preview-warning" v-if="this.chargeConfirmFailed">
                    <i class="fas fa-exclamation-circle"></i>
                    Plata a eșuat
                </span>
                <span class="camera-preview-timer" v-else-if="this.timerStarted">
                    <i class="fas fa-clock"></i>
                    {{ (this.minutes < 10) ? '0'+this.minutes : this.minutes }}:
                    {{ (this.seconds < 10) ? '0'+this.seconds : this.seconds }}
                </span>
                <span class="camera-preview-text" v-else>
                      <i class="fas fa-info-circle"/>
                      Sedința va începe în curând
                </span>
                <div class="camera-preview" id="localTrack"></div>
                <div class="fullscreen-button">
                    <i class="fas fa-expand top-control-icon" @click="toggleFullscreen"></i>
                </div>
                <div class="rotate-button" id="rotateButtonLandscape">
                    <i class="fas fa-undo top-control-icon"></i>
                </div>
                <div class="flash-new-message" :class="{'flash': this.flashMessageAnimation}" id="flashMessage">
                    <span>{{flashMessageText}}</span>
                </div>
                <div id="remoteTrack"></div>
            </div>

            <CallControls v-if="this.twilioRoom" @close="endCall" @micStatus="toggleMic" @videoStatus="toggleVideo" @retryDevices="openJoinWithProblems" :hasMic="this.localUser.microphone !== null" :hasVideo="this.localUser.video !== null"/>
        </div>
          <Chat :localUser="this.localUser" ref="chat" @userJoined="updateLocalUser" @newMessage="flashMessage($event)"/>
          <MeetingEndModal v-if="endModal.active" @close="leaveMeeting" :endMessage="this.endMessage" />


          <JoinWithProblemsModal v-if="this.showJoinWithProblems" @close="closeJoinWithProblems"/>
          <SpecialistNotConnectedModal v-if="this.showSpecialistNotConnected" @close="leaveMeeting"/>
          <audio style="display: none;" preload="none" id="meeting-joinleave-audio">
            <source src="@/assets/audio/userjoinorleave.mp3" type="audio/mpeg">
          </audio>
          <audio style="display: none;" preload="none" id="meeting-timeleft-audio">
            <source src="@/assets/audio/timeleft.mp3" type="audio/mpeg">
          </audio>

        <PaymentModal v-if="$store.state.payments.modal.active"/>
    </div>
</template>

<script>
import { mapActions } from "vuex";
import { mapGetters } from "vuex";
import router from "@/router.js";
import * as moment from "moment";

import UiNotification from "@/components/ui/Notification";
import Chat from "./Chat.vue";
import CallControls from "./CallControls.vue";
import CameraPreview from "./CameraPreview.vue";
import JoinWithProblemsModal from "./JoinWithProblemsModal";
import MeetingEndModal from "./MeetingEndModal";
import SpecialistNotConnectedModal from "./SpecialistNotConnectedModal";

import Twilio, {
  connect,
  createLocalTracks,
  createLocalVideoTrack,
} from "twilio-video";
import TransactionCardVue from "../specialist/TransactionsPage/components/TransactionCard.vue";

import PaymentModal from "@/layouts/Dashboard/components/PaymentModal";

export default {
  components: {
    Chat,
    CallControls,
    CameraPreview,
    UiNotification,
    JoinWithProblemsModal,
    MeetingEndModal,
    SpecialistNotConnectedModal,
    PaymentModal,
  },
  data() {
    return {
      minutes: 0,
      seconds: 0,
      timerStarted: null,
      timerInterval: null,
      chargeConfirmFailed: false,
      chargeConfirmTimeout: null,
      flashMessageAnimation: false,
      flashMessageText: "",
      joinWithVideo: true,
      localUser: {},
      localVideoTrack: "",
      localAudioTrack: "",
      remoteTrack: "",
      twilioRoom: "",
      showJoinWithProblems: false,
      showSpecialistNotConnected: false,
      endMessage: '',
    };
  },
  created() {
    //Request meeting join to Laravel API
    this.joinMeetingRoom(this.$router.currentRoute.query.token);
  },
  computed: {
    ...mapGetters({
      user: "user/user",
      endModal: "anytimeMeeting/endModal",
      twilioToken: "anytimeMeeting/twilioToken",
      roomHash: "anytimeMeeting/roomHash",
      meeting: "anytimeMeeting/meeting",
    }),
    isMobile() {
      if (
        /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
          navigator.userAgent
        ) ||
        window.innerWidth < 1200
      ) {
        return true;
      }
      return false;
    },
  },
  watch: {
    twilioToken: {
      //**ALL STARTS FROM HERE -> WHEN THE USER IS APPENDED IN STATE
      handler(newVal) {
        if (newVal != null && this.twilioRoom == "") {
          // check if userId from state is available
          this.joinVideoRoom();
        }
      },
      immediate: true, // make this watch function is called when component created
    },
  },
  methods: {
    ...mapActions({
      joinMeetingRoom: "anytimeMeeting/join",
    }),
    startTimer(startedAt = null) {
      //Anytime meeting timer - added by Andrei Preda?
      if(this.timerStarted) return; //Avoid setting multiple intervals
      var diffFromNow;

      if (!startedAt) {
        if (this.meeting.specialist_joined_at != null && this.meeting.client_joined_at != null){
          var specialistJoinedAt = new Date(this.meeting.specialist_joined_at).getTime();
          var clientJoinedAt = new Date(this.meeting.client_joined_at).getTime();

          if (clientJoinedAt > specialistJoinedAt)
            diffFromNow = new Date().getTime() - clientJoinedAt;
          else diffFromNow = new Date().getTime() - specialistJoinedAt;

          this.timerStarted = true;
        }
      } else {
        var startedAtDate = new Date(startedAt).getTime();
        diffFromNow = new Date().getTime() - startedAtDate;
        this.timerStarted = true;
      }

      if(this.timerStarted){
        this.minutes += Math.floor(diffFromNow / 60000);
        this.seconds = ((diffFromNow % 60000) / 1000).toFixed(0);

        if (this.minutes < 0) {
          this.minutes = 0;
        }

        this.timerInterval = setInterval(() => {
          if (this.seconds == 59) {
            this.minutes += 1;
            this.seconds = 0;
            if (this.$store.state.user.user.balance) this.$store.state.user.user.balance--; //Fix bug tips balance at meeting end.
          } else {
            this.seconds = Number(this.seconds) + 1;
          }
        }, 1000);

        if (diffFromNow < 605000) {
          this.chargeConfirmTimeout = setTimeout(() => {
            this.notifyWarningChargeFailed();
          }, (605000 - diffFromNow)); // 10 minutes + 5s
        }
      }
    },
    openSpecialistNotConnected() {
      this.showSpecialistNotConnected = true;
    },
    closeJoinWithProblems() {
      this.showJoinWithProblems = false;
    },
    openJoinWithProblems() {
      this.showJoinWithProblems = true;
    },
    notifyWarningChargeFailed() {
      if (localStorage.getItem("role") === 'client') {
        return;
      }

      clearInterval(this.timerInterval);
      this.chargeConfirmFailed = true;

      this.$store.state.notification.notification.icon = null;
      this.$store.state.notification.notification.title = null;

      setTimeout(() => {
        this.$store.state.notification.notification.icon = "warning";
        this.$store.state.notification.notification.title = "Atenție! Plata pentru următorul minut nu a putut fi efectuată de către client!";

        let audio = document.getElementById("meeting-timeleft-audio");
        audio.play();
      }, 200);
    },
    notifyWarningMinutes(minutes) {
      var message =
        "Intalnirea se apropie de sfarsit! Mai aveti " +
        minutes +
        " minute ramase.";
      if (minutes == 1)
        message =
          "Intalnirea se apropie de sfarsit! Camera se va inchide intr-un minut.";

      //Notify
      this.$store.state.notification.notification.icon = null;
      this.$store.state.notification.notification.title = null;
      setTimeout(() => {
        this.$store.state.notification.notification.icon = "info";
        this.$store.state.notification.notification.title = message;
        let audio = document.getElementById("meeting-timeleft-audio");
        audio.play();
      }, 200);
    },
    flashMessage(message) {
      let meetingRoomElement = document.getElementsByClassName(
        "meeting-room"
      )[0];
      let mobileRotateButton = document.getElementById("rotateButtonLandscape");

      if (
        meetingRoomElement.classList.contains("fullscreen") ||
        window.getComputedStyle(mobileRotateButton).display === "block"
      ) {
        let reflashed = false;
        if (this.flashMessageAnimation == true) reflashed = true;

        this.flashMessageAnimation = true;
        if (typeof message.body === "object")
          if (message.body.type.startsWith("image"))
            this.flashMessageText = "[IMAGINE RECEPȚIONATĂ]";
          else if (message.body.type.startsWith("video"))
            this.flashMessageText = "[VIDEOCLIP RECEPȚIONAT]";
          else this.flashMessageText = "[DOCUMENT RECEPȚIONAT]";
        else if (message.body.length > 20)
          this.flashMessageText = message.body.substr(0, 19) + "...";
        else this.flashMessageText = message.body;

        let VueThis = this;
        setTimeout(function () {
          if (reflashed == false) VueThis.flashMessageAnimation = false;
          reflashed = false;
        }, 5000);
      }
    },
    //Meeting room controls
    updateLocalUser() {
      this.localUser.online = true;

      if (this.localAudioTrack)
        if (this.localAudioTrack.isEnabled) this.localUser.microphone = true;
        else this.localUser.microphone = false;
      else this.localUser.microphone = null;

      if (this.localVideoTrack)
        if (this.localVideoTrack.isEnabled) this.localUser.video = true;
        else this.localUser.video = false;
      else this.localUser.video = null;

      let eventData = {
        event: "status_update",
        localUser: this.localUser,
        roomHash: this.roomHash,
      };

      this.$socket.emit("status_update", eventData); //send message to socket server
    },
    endCall() {
      //Disconnect user from twilio room
      if (this.twilioRoom) this.twilioRoom.disconnect();

      //Emit disconnect event;
      this.$socket.emit("anytime_room_leave", {});

      //If > 10 minutes, show tips button
      if(this.minutes >= 10 || this.endMessage != '') this.$store.state.anytimeMeeting.endModal.active = true;
      else this.leaveMeeting();
    },
    leaveMeeting() {
      //I. Unsubscribe to roomHash channel
      this.sockets.unsubscribe(this.roomHash);

      //II. Redirect user out of meeting room
      this.$store.state.anytimeMeeting.endModal.active = false;
      var token = localStorage.getItem("token");
      var role = localStorage.getItem("role");

      if (token && role) {
        //If user auth - redirect to dashboard
        router.push("/" + role + "/appointments");
        location.reload();
      } else {
        //Else, redirect to login
        router.push("/login");
        location.reload();
      }
    },
    toggleFullscreen() {
      let meetingRoomElement = document.getElementsByClassName(
        "meeting-room"
      )[0];

      if (meetingRoomElement.classList.contains("fullscreen")) {
        meetingRoomElement.classList.remove("fullscreen");
        document.exitFullscreen();
      } else {
        meetingRoomElement.classList.add("fullscreen");
        meetingRoomElement.requestFullscreen();
      }
    },
    toggleVideo(status) {
      if (status == true && this.localVideoTrack.isEnabled == false)
        this.localVideoTrack.enable();

      if (status == false && this.localVideoTrack.isEnabled == true)
        this.localVideoTrack.disable();

      this.updateLocalUser();
    },
    toggleMic(status) {
      if (status == true && this.localAudioTrack.isEnabled == false)
        this.localAudioTrack.enable();

      if (status == false && this.localAudioTrack.isEnabled == true)
        this.localAudioTrack.disable();

      this.updateLocalUser();
    },
    joinVideoRoom() {
      var VueThis = this;
      const apiToken = this.twilioToken;
      let joinWithVideo = this.$router.currentRoute.query.joinVideo;
      let joinWithAudio = this.$router.currentRoute.query.joinAudio;
      joinWithAudio = joinWithAudio == "false" ? false : true;
      joinWithVideo = joinWithVideo == "false" ? false : { width: 720 };

      //Subscribe to roomHash channel
      this.sockets.subscribe(this.roomHash, data => {
        switch(data.event){
          case 'meeting_close':
            if(this.endMessage == '') this.endMessage = data.message;
            clearInterval(this.timerInterval);
            this.endCall();
            break;
          case 'meeting_started':
            this.startTimer(data.started_at);
            break;
          case 'meeting_update':
            if (this.chargeConfirmTimeout !== null) {
              clearTimeout(this.chargeConfirmTimeout);
            }

            this.chargeConfirmTimeout = setTimeout(() => {
              this.notifyWarningChargeFailed();
            }, 65000); // 1 minute + 5s

            let remainingMinutes = parseInt(data.remaining_minutes);

            if(remainingMinutes < 5) {
              this.$store.state.notification.notification.icon = null;
              this.$store.state.notification.notification.title = null;
              setTimeout(() => {
                this.$store.state.notification.notification.icon = "info";

                if (localStorage.getItem("role") === 'client') {
                  this.$store.state.notification.notification.title =
                  "Sesiunea se apropie de sfârșit. Mai aveți credite pentru înca "+remainingMinutes+" minute.";
                } else {
                  this.$store.state.notification.notification.title =
                  "Sesiunea se apropie de sfârșit. Clientul mai are credite pentru înca "+remainingMinutes+" minute.";
                }
                let audio = document.getElementById("meeting-joinleave-audio");
                audio.play();
              }, 200);
            }

            break;
        }
      })

      //Emit join event
      let eventData = {
        room_hash: this.roomHash,
        role: localStorage.getItem("role"),
        id: this.user.id,
      };

      this.$socket.emit('anytime_room_join', eventData);
      console.log(eventData);

      //Try to start meeting timer
      this.startTimer();

      if (joinWithAudio == false && joinWithVideo == false) {
        this.openJoinWithProblems();
        console.log("Meeting join with problems");
      }

      console.log("Trying to connect to room: " + this.roomHash);

      Twilio.connect(apiToken, {
        name: this.roomHash,
        audio: joinWithAudio,
        video: joinWithVideo,
      }).then(
        (room) => {
          this.twilioRoom = room;
          console.log(`Successfully joined a Room: ${room}`);

          //FOR REMOTE PARTICIPANTS THAT ARE ALREADY IN ROOM
          room.participants.forEach((participant) => {
            participant.tracks.forEach((publication) => {
              if (publication.track) {
                document
                  .getElementById("remoteTrack")
                  .appendChild(publication.track.attach());
              }
            });

            participant.on("trackSubscribed", (track) => {
              document
                .getElementById("remoteTrack")
                .appendChild(track.attach());
            });
          });

          //EVENT WHEN PARTICIPANT CONNECTS
          room.on("participantConnected", (participant) => {
            console.log(`Participant "${participant.identity}" connected`);

            this.$store.state.notification.notification.icon = null;
            this.$store.state.notification.notification.title = null;
            setTimeout(() => {
              this.$store.state.notification.notification.icon = "info";
              this.$store.state.notification.notification.title =
                participant.identity + " s-a alaturat conversatiei.";
              let audio = document.getElementById("meeting-joinleave-audio");
              audio.play();
            }, 200);

            participant.tracks.forEach((publication) => {
              if (publication.isSubscribed) {
                const track = publication.track;
                document
                  .getElementById("remoteTrack")
                  .appendChild(track.attach());
              }
            });

            participant.on("trackSubscribed", (track) => {
              document
                .getElementById("remoteTrack")
                .appendChild(track.attach());
            });
          });

          room.on("participantDisconnected", (participant) => {            
            this.$store.state.notification.notification.icon = null;
            this.$store.state.notification.notification.title = null;
            setTimeout(() => {
              this.$store.state.notification.notification.icon = "info";
              this.$store.state.notification.notification.title =
                participant.identity + " a parasit conversatia.";
              let audio = document.getElementById("meeting-joinleave-audio");
              audio.play();
            }, 200);

            VueThis.$refs.chat.remoteUserDisconnect();
            VueThis.$refs.chat.remoteUserDisconnect();
          });

          room.localParticipant.tracks.forEach((publication) => {
            if (publication.kind == "video") {
              VueThis.localVideoTrack = publication.track;
              let localMediaContainer = document.getElementById("localTrack");
              localMediaContainer.appendChild(publication.track.attach());
            }

            if (publication.kind == "audio")
              VueThis.localAudioTrack = publication.track;
          });

          room.on("disconnected", (room) => {
            // Detach the local media elements
            room.localParticipant.tracks.forEach((publication) => {
              const attachedElements = publication.track.detach();
              attachedElements.forEach((element) => element.remove());
            });
          });

          this.updateLocalUser(); //update localUser in order to send it to the remoteUser
        },
        (error) => {
          console.error(`Unable to connect to Room: ${error.message}`);
          if (joinWithVideo !== false) {
            this.$router.push({
              path: this.$router.currentRoute.path,
              query: {
                token: this.$router.currentRoute.query.token,
                joinVideo: "false",
              },
            });
            location.reload();
          } else {
            this.$router.push({
              path: this.$router.currentRoute.path,
              query: {
                token: this.$router.currentRoute.query.token,
                joinVideo: "false",
                joinAudio: "false",
              },
            });
            location.reload();
          }
        }
      );
    },
  },
  mounted() {
    //Hide Tawk.to from this page
    setTimeout(function () {
      let tawkIframe = document.querySelectorAll("iframe[title='chat widget']");
      if (tawkIframe[0] !== undefined) {
        tawkIframe[0].parentElement.style.setProperty(
          "display",
          "none",
          "important"
        );
      }
    }, 3000);
    //=========RESPONSIVENESS SCRIPTS ACROSS DEVICES==========
    //Screen size / orientation change logic + textarea input expand logic
    var lastTextareaHeight;
    function autoExpandInput(field) {
      let heightLimit = 100;

      // Reset field height
      field.style.height = "25px";

      // Calculate the height
      var height = +field.scrollHeight;

      if (height > heightLimit) field.style.height = lastTextareaHeight + "px";
      else {
        field.style.height = height + "px";
        lastTextareaHeight = height;
      }
    }
    let sendMsgTextarea = document.getElementById("message-textarea");
    sendMsgTextarea.addEventListener(
      "input",
      function (event) {
        if (event.target.tagName.toLowerCase() !== "textarea") return;
        autoExpandInput(event.target);
      },
      false
    );

    /* FULLSCREEN TOGGLERS EVENT  */
    window.onload = function () {
      //IOS OVERFLOW FIX - set inner window height at first load
      var meetingRoomElement = document.getElementsByClassName(
        "meeting-room"
      )[0];
      meetingRoomElement.style.height = window.innerHeight + "px";
    };
    window.onorientationchange = function () {
      //required for resizing when going from landscape to portrait and vice-versa
      let meetingRoomElement = document.getElementsByClassName(
        "meeting-room"
      )[0];

      setTimeout(function () {
        meetingRoomElement.style.height = window.innerHeight + "px";

        setTimeout(function () {
          window.scrollTo(0, 100);
        }, "3000");
      }, "500");
    };

    //To prevent meetingRoom resizing when keyboard is shown up, use document.activeElement === sendMsgTextarea
    window.onresize = function () {
      if (!(document.activeElement === sendMsgTextarea)) {
        var meetingRoomElement = document.getElementsByClassName(
          "meeting-room"
        )[0];
        meetingRoomElement.style.height = window.innerHeight + "px";
      }
    };
    window.onscroll = function () {
      //for landscape only [needs double check before added in production]
      if (!(document.activeElement === sendMsgTextarea)) {
        var meetingRoomElement = document.getElementsByClassName(
          "meeting-room"
        )[0];
        meetingRoomElement.style.height = window.innerHeight + "px";
      }
    };
  },
  destroyed() {
    //Hide Tawk.to from this page
    let tawkIframe = document.querySelectorAll("iframe[title='chat widget']");
    if (tawkIframe[0] !== undefined)
      tawkIframe[0].parentElement.style.display = "initial";

    this.sockets.unsubscribe(this.roomHash);
    clearInterval(this.timerInterval);
  },
};
</script>

<style lang="css">
@keyframes flash {
  0% {
    opacity: 0;
  }
  25% {
    opacity: 1;
  }
  50% {
    opacity: 1;
  }
  75% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
}

.flash-new-message {
  position: absolute;
  background-color: red;
  width: 100%;
  height: 100%;
  display: flex;
  opacity: 0%;
  z-index: 5;
  display: none;
}

.flash-new-message.flash {
  background-color: #00bcd4;
  animation: flash 5s linear;
  display: flex;
}

.flash-new-message > span {
  margin: auto;
  text-align: center;
  font-size: 24px;
  color: white;
  max-width: 80vw;
  text-overflow: ellipsis;
}

#localTrack {
  z-index: 5;
  display: flex;
}

#localTrack > video {
  position: absolute;
  top: 0px;
  left: 0px;
  width: 32vmin;
  height: 18vmin;
  z-index: 1;
  margin: auto;
}

#remoteTrack {
  display: flex;
}

#remoteTrack > video {
  position: absolute;
  left: 50%;
  transform: translate(-50%, 0);
  height: 100%;
  margin: auto;
}
</style>

<style lang="scss">
@import "@/scss/pages/meeting-room";
</style>
